/* theme.js — Cart API, Section Rendering */

(function() {
  'use strict';

/* ===== Shopify money format ===== */
  if (!window.Shopify) window.Shopify = {};
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = (cents / 100).toFixed(2);
    return '$' + value;
  };

  /* ===== Cart API ===== */
  let cartUpdateController = null;
  window.updateCartItem = async function(key, quantity) {
    if (cartUpdateController) cartUpdateController.abort();
    cartUpdateController = new AbortController();
    window.dispatchEvent(new CustomEvent('cart-loading'));
    try {
      // Optimistic UI: hide item immediately if removing
      if (quantity === 0) {
        const itemEl = document.querySelector('[data-cart-item="' + key + '"]');
        if (itemEl) {
          itemEl.style.transition = 'opacity 0.15s, max-height 0.2s';
          itemEl.style.opacity = '0';
          itemEl.style.overflow = 'hidden';
          itemEl.style.maxHeight = itemEl.offsetHeight + 'px';
          setTimeout(function() { itemEl.style.maxHeight = '0'; itemEl.style.padding = '0'; itemEl.style.margin = '0'; }, 50);
        }
      }
      // Fire change + refresh section in parallel (change must finish first for correct data)
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
        signal: cartUpdateController.signal
      });
      if (!res.ok) throw new Error('Cart update failed');
      await refreshCart();
    } catch (e) {
      if (e.name === 'AbortError') return;
      console.error('Cart update failed:', e);
    }
  };

  window.updateCartNote = async function(note) {
    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note })
      });
      if (!res.ok) throw new Error('Cart note update failed');
    } catch (e) {
      console.error('Cart note update failed:', e);
    }
  };

  async function refreshCart() {
    window.dispatchEvent(new CustomEvent('cart-loading'));
    try {
      // Run all fetches in parallel for speed
      const cartPageEl = document.querySelector('[data-cart-page]');
      const fetches = [
        fetch('/cart.js').then(function(r) { if (!r.ok) throw new Error('Cart fetch failed'); return r.json(); }),
        fetch('/?section_id=cart-drawer').then(function(r) { if (!r.ok) throw new Error('Cart drawer fetch failed'); return r.text(); })
      ];
      if (cartPageEl) {
        const sectionId = cartPageEl.getAttribute('data-section-id');
        fetches.push(fetch('/cart?section_id=' + sectionId).then(function(r) { if (!r.ok) throw new Error('Cart page fetch failed'); return r.text(); }));
      }
      const results = await Promise.all(fetches);
      const cartData = results[0];
      const html = results[1];

      // Update cart count badge
      const countEls = document.querySelectorAll('[data-cart-count]');
      countEls.forEach(function(el) {
        el.textContent = cartData.item_count;
        el.classList.toggle('hidden', cartData.item_count === 0);
      });
      // Re-render cart drawer via section rendering API
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      // Update drawer body (line items, shipping progress)
      const drawerEl = document.querySelector('[data-drawer-cart]');
      if (drawerEl) {
        const newContent = doc.querySelector('[data-drawer-cart]');
        if (newContent) drawerEl.innerHTML = newContent.innerHTML;
      }
      // Update drawer footer (subtotal, checkout button)
      const footerEl = document.querySelector('[data-drawer-footer]');
      const newFooter = doc.querySelector('[data-drawer-footer]');
      if (footerEl && newFooter) {
        footerEl.innerHTML = newFooter.innerHTML;
      } else if (footerEl && !newFooter) {
        footerEl.remove();
      } else if (!footerEl && newFooter && drawerEl) {
        drawerEl.parentElement.appendChild(newFooter);
      }
      // Re-render main cart page if present
      if (cartPageEl && results[2]) {
        const cartDoc = new DOMParser().parseFromString(results[2], 'text/html');
        const newCartPage = cartDoc.querySelector('[data-cart-page]');
        if (newCartPage) cartPageEl.innerHTML = newCartPage.innerHTML;
      }
    } catch (e) {
      console.error('Cart refresh failed:', e);
    } finally {
      window.dispatchEvent(new CustomEvent('cart-ready'));
    }
  }

  /* ===== Add to Cart (intercept form) ===== */
  document.addEventListener('submit', async function(e) {
    const form = e.target;
    if (!form.hasAttribute('data-product-form')) return;
    e.preventDefault();

    const submitBtn = form.querySelector('[data-add-to-cart]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const formData = new FormData(form);
      const data = {};
      const properties = {};
      formData.forEach(function(value, key) {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match) {
          properties[match[1]] = value;
        } else {
          data[key] = value;
        }
      });

      const item = { id: parseInt(data.id), quantity: parseInt(data.quantity) || 1 };
      if (Object.keys(properties).length > 0) item.properties = properties;

      // Open drawer + show loading immediately
      window.dispatchEvent(new CustomEvent('cart-loading'));
      window.dispatchEvent(new CustomEvent('cart-drawer-open'));

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [item] })
      });
      if (!addRes.ok) throw new Error('Add to cart failed');

      await refreshCart();
    } catch (e) {
      console.error('Add to cart failed:', e);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  });

  /* ===== Sliders: native scroll-snap first, Embla where it cannot reach =====
     snapSlider: the markup lays the slides out itself (Tailwind widths +
     snap-start inside an overflow-x track, x-ref="track", which must be
     `relative` so slide offsetLeft is measured against it). This component only
     mirrors scroll state for arrows/dots. Arrows move a page (or one slide)
     at a time and rewind at either end; swiping stops at the ends. Touch and trackpads scroll
     the track natively; a mouse does not, so mouse drag is added here.
     It registers before Alpine starts (theme.js loads first) and Alpine tears it
     down when the theme editor swaps a section. Embla components live in
     product.js (productGallery) and content.js (loopCarousel). */
  /* A link or image inside a slider would otherwise start the browser's own
     drag-and-drop, which cancels the pointer stream mid-drag. */
  function preventNativeDrag(e) {
    if (e.target.closest && e.target.closest('a, img')) e.preventDefault();
  }

  document.addEventListener('alpine:init', function () {
    /* opts: { rewind (default true), step: 'page' (default) | 'slide' }.
       A page is as many slides as fit whole in the track (perView, at least 1),
       the way Splide counted pages from perPage, so a 67% peek slider gets one
       dot per card and a 5-per-view row one dot per 5 cards. step 'slide' moves
       one card per arrow click (Splide's focus:center behaviour). Each slide's
       resting position follows its own scroll-snap-align (start or center), so
       arrows, dots, drag and the browser's own snap all land on the same spots. */
    Alpine.data('snapSlider', function (opts) {
      opts = opts || {};
      var ro = null;
      var restoreTimer = 0;
      /* Splide honoured prefers-reduced-motion (speed 0); so do arrows and dots here. */
      var motion = function () {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      };
      return {
        index: 0,
        count: 0,
        perView: 1,
        page: 0,
        pages: 1,
        atStart: true,
        atEnd: false,
        overflows: false,
        /* Scroll position at which slide i rests. */
        snapPos: function (i) {
          var track = this.$refs.track;
          var slides = track.children;
          if (!slides[i]) return 0;
          var max = track.scrollWidth - track.clientWidth;
          var pos = slides[i].offsetLeft - slides[0].offsetLeft;
          if (getComputedStyle(slides[i]).scrollSnapAlign.indexOf('center') !== -1) {
            pos -= (track.clientWidth - slides[i].offsetWidth) / 2;
          }
          return Math.max(0, Math.min(max, pos));
        },
        nearest: function (x) {
          var best = 0, bestD = Infinity;
          for (var i = 0; i < this.$refs.track.children.length; i++) {
            var d = Math.abs(this.snapPos(i) - x);
            if (d < bestD) { bestD = d; best = i; }
          }
          return best;
        },
        init: function () {
          var self = this;
          var track = this.$refs.track;
          var root = this.$root;
          var raf = 0;
          var drag = null;
          var swallowClick = false;
          /* Grab cursor only for a real mouse; touch screens never show it. */
          var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

          /* The carousel semantics Splide put on its root. */
          if (!root.hasAttribute('role')) root.setAttribute('role', 'region');
          if (!root.hasAttribute('aria-roledescription')) root.setAttribute('aria-roledescription', 'carousel');
          if (!root.hasAttribute('aria-label') && track.getAttribute('aria-label')) root.setAttribute('aria-label', track.getAttribute('aria-label'));

          function update() {
            raf = 0;
            var slides = track.children;
            var x = track.scrollLeft;
            var w = track.clientWidth;
            var max = track.scrollWidth - w;
            self.count = slides.length;
            /* A track that is overflow-hidden at this breakpoint (a static row
               on desktop) is not a slider there, even if its content is wider. */
            var ox = getComputedStyle(track).overflowX;
            self.overflows = max > 1 && (ox === 'auto' || ox === 'scroll');
            if (!drag || !drag.moved) track.style.cursor = self.overflows && finePointer ? 'grab' : '';
            self.atStart = x <= 1;
            self.atEnd = x >= max - 1;
            var stride = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : (slides[0] ? slides[0].offsetWidth : 0);
            self.perView = stride > 0 ? Math.max(1, Math.floor(w / stride + 0.02)) : 1;
            self.index = self.nearest(x);
            self.pages = self.overflows ? Math.ceil((self.count - self.perView) / self.perView) + 1 : 1;
            self.page = self.atEnd ? self.pages - 1 : Math.min(self.pages - 1, Math.round(self.index / self.perView));
          }
          this._schedule = function () { if (!raf) raf = requestAnimationFrame(update); };
          track.addEventListener('scroll', this._schedule, { passive: true });
          /* Also covers a track that starts inside display:none (shop-by-print
             tabs): it measures 0 until shown, then the observer fires. */
          ro = new ResizeObserver(this._schedule);
          ro.observe(track);
          update();

          /* Mouse drag. Snap is switched off while dragging (otherwise the
             browser re-snaps on every scrollLeft write), then the track settles
             on the nearest slide, biased in the drag direction. A drag swallows
             the click that follows so a card link does not open. */
          function endDrag() {
            track.style.userSelect = '';
            track.style.cursor = self.overflows && finePointer ? 'grab' : '';
          }
          this._down = function (e) {
            swallowClick = false;
            if (e.pointerType !== 'mouse' || e.button !== 0 || !self.overflows) return;
            if (e.target.closest('input, select, textarea, button')) return;
            drag = { x: e.clientX, left: track.scrollLeft, moved: false, id: e.pointerId };
          };
          this._move = function (e) {
            if (!drag) return;
            /* Button released outside the track: this is a hover, not a drag. */
            if (!(e.buttons & 1)) {
              var was = drag.moved;
              drag = null;
              if (was) { endDrag(); track.style.scrollSnapType = ''; }
              return;
            }
            var dx = e.clientX - drag.x;
            if (!drag.moved) {
              if (Math.abs(dx) < 5) return;
              drag.moved = true;
              clearTimeout(restoreTimer);
              try { track.setPointerCapture(drag.id); } catch (err) {}
              track.style.scrollSnapType = 'none';
              track.style.scrollBehavior = 'auto';
              track.style.userSelect = 'none';
              track.style.cursor = 'grabbing';
            }
            track.scrollLeft = drag.left - dx;
          };
          this._up = function () {
            if (!drag) return;
            var d = drag;
            drag = null;
            if (!d.moved) return;
            swallowClick = true;
            endDrag();
            var dir = track.scrollLeft > d.left ? 1 : -1;
            var first = track.children[0];
            var aim = track.scrollLeft + dir * (first ? first.offsetWidth : 0) * 0.3;
            var from = self.nearest(d.left);
            var to = self.nearest(aim);
            /* A short drag (40px, as Embla/Splide count a swipe) already moves one
               slide; wide slides would otherwise need a third of their width. */
            if (to === from && Math.abs(track.scrollLeft - d.left) > 40) {
              to = Math.max(0, Math.min(track.children.length - 1, from + dir));
            }
            var target = self.snapPos(to);
            track.style.scrollBehavior = '';
            track.scrollTo({ left: target, behavior: motion() });
            /* Restore snap once the smooth scroll has landed. scrollend never
               fires when there is nothing left to scroll, so a timeout backs it up. */
            var restored = false;
            var restore = function () {
              if (restored) return;
              restored = true;
              clearTimeout(restoreTimer);
              track.removeEventListener('scrollend', restore);
              if (!drag || !drag.moved) track.style.scrollSnapType = '';
            };
            if (Math.abs(track.scrollLeft - target) < 1) { restore(); return; }
            if ('onscrollend' in window) track.addEventListener('scrollend', restore);
            restoreTimer = setTimeout(restore, 700);
          };
          this._click = function (e) {
            if (!swallowClick) return;
            swallowClick = false;
            e.preventDefault();
            e.stopPropagation();
          };
          track.addEventListener('pointerdown', this._down);
          track.addEventListener('pointermove', this._move);
          track.addEventListener('pointerup', this._up);
          track.addEventListener('pointercancel', this._up);
          track.addEventListener('click', this._click, true);
          track.addEventListener('dragstart', preventNativeDrag);
        },
        goTo: function (i) {
          if (!this.$refs.track.children[i]) return;
          this.$refs.track.scrollTo({ left: this.snapPos(i), behavior: motion() });
        },
        goPage: function (p) {
          this.goTo(Math.min(this.count - 1, p * this.perView));
        },
        next: function () {
          var track = this.$refs.track;
          if (this.atEnd) { if (opts.rewind !== false) track.scrollTo({ left: 0, behavior: motion() }); return; }
          this.goTo(Math.min(this.count - 1, this.index + (opts.step === 'slide' ? 1 : this.perView)));
        },
        prev: function () {
          var track = this.$refs.track;
          if (this.atStart) { if (opts.rewind !== false) track.scrollTo({ left: track.scrollWidth, behavior: motion() }); return; }
          this.goTo(Math.max(0, this.index - (opts.step === 'slide' ? 1 : this.perView)));
        },
        destroy: function () {
          var track = this.$refs.track;
          clearTimeout(restoreTimer);
          if (ro) ro.disconnect();
          track.removeEventListener('scroll', this._schedule);
          track.removeEventListener('pointerdown', this._down);
          track.removeEventListener('pointermove', this._move);
          track.removeEventListener('pointerup', this._up);
          track.removeEventListener('pointercancel', this._up);
          track.removeEventListener('click', this._click, true);
          track.removeEventListener('dragstart', preventNativeDrag);
        }
      };
    });
  });

  /* ===== Gift Wrap ===== */
  (function() {
    let giftProductId = null;
    let modalReady = false;

    function getModal() {
      return document.getElementById('gift-wrap-modal');
    }

    function openModal() {
      const modal = getModal();
      if (modal) {
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }
    }

    function closeModal() {
      const modal = getModal();
      if (modal) {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    }

    function setupModal() {
      if (modalReady) return;
      const modal = getModal();
      if (!modal) return;
      modalReady = true;

      const textarea = modal.querySelector('.gift-wrap__message');
      const charCurrent = modal.querySelector('.gift-wrap__char-current');
      const closeBtn = modal.querySelector('.gift-wrap__modal-close');
      const saveBtn = modal.querySelector('.gift-wrap__save');
      const variantId = modal.dataset.giftVariantId;
      giftProductId = modal.dataset.giftProductId;

      textarea.addEventListener('input', function() {
        charCurrent.textContent = textarea.value.length;
      });

      closeBtn.addEventListener('click', function() {
        closeModal();
        syncAllCheckboxes();
      });

      modal.querySelector('.gift-wrap__modal-inner').addEventListener('click', function(e) {
        e.stopPropagation();
      });
      modal.addEventListener('click', function() {
        closeModal();
        syncAllCheckboxes();
      });

      saveBtn.addEventListener('click', function() {
        saveBtn.disabled = true;
        saveBtn.textContent = 'Saving...';
        const message = textarea.value.trim();

        const addItem = function() {
          const body = { id: parseInt(variantId), quantity: 1, properties: {} };
          if (message) body.properties['Gift Message'] = message;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
          }).then(function(r) {
            if (!r.ok) throw new Error('Gift wrap add failed');
            return r.json();
          });
        };

        // Remove existing gift item first, then add new one
        getGiftItemKey().then(function(key) {
          if (key) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            }).then(function(r) {
              if (!r.ok) throw new Error('Gift wrap remove failed');
              return addItem();
            });
          }
          return addItem();
        }).then(function() {
          closeModal();
          refreshCart();
        }).catch(function(e) {
          console.error('Gift wrap error:', e);
          window.dispatchEvent(new CustomEvent('cart-error', {
            detail: { message: 'Could not add gift wrap. Please try again.' }
          }));
        }).finally(function() {
          saveBtn.disabled = false;
          saveBtn.textContent = 'Save';
        });
      });
    }

    function getGiftItemKey() {
      return fetch('/cart.js')
        .then(function(r) {
          if (!r.ok) throw new Error('Cart fetch failed');
          return r.json();
        })
        .then(function(cart) {
          for (let i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].product_id) === String(giftProductId)) {
              return cart.items[i].key;
            }
          }
          return null;
        });
    }

    function removeGiftFromCart() {
      return getGiftItemKey().then(function(key) {
        if (!key) return;
        // Optimistic UI: hide gift item immediately
        const itemEl = document.querySelector('[data-cart-item="' + key + '"]');
        if (itemEl) {
          itemEl.style.transition = 'opacity 0.15s, max-height 0.2s';
          itemEl.style.opacity = '0';
          itemEl.style.overflow = 'hidden';
          itemEl.style.maxHeight = itemEl.offsetHeight + 'px';
          setTimeout(function() { itemEl.style.maxHeight = '0'; itemEl.style.padding = '0'; itemEl.style.margin = '0'; }, 50);
        }
        window.dispatchEvent(new CustomEvent('cart-loading'));
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).then(function(r) {
          if (!r.ok) throw new Error('Gift wrap remove failed');
        });
      }).then(function() {
        refreshCart();
      });
    }

    function syncAllCheckboxes() {
      if (!giftProductId) return;
      fetch('/cart.js')
        .then(function(r) {
          if (!r.ok) throw new Error('Cart fetch failed');
          return r.json();
        })
        .then(function(cart) {
          let found = false;
          for (let i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].product_id) === String(giftProductId)) {
              found = true;
              break;
            }
          }
          document.querySelectorAll('.gift-wrap__checkbox').forEach(function(cb) {
            cb.checked = found;
          });
        });
    }

    function bindCheckboxes() {
      document.querySelectorAll('.gift-wrap__checkbox').forEach(function(cb) {
        if (cb.dataset.giftBound) return;
        cb.dataset.giftBound = 'true';
        cb.addEventListener('change', function() {
          if (cb.checked) {
            openModal();
          } else {
            removeGiftFromCart();
          }
        });
      });
    }

    function init() {
      setupModal();
      bindCheckboxes();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    window.addEventListener('cart-ready', function() {
      bindCheckboxes();
      syncAllCheckboxes();
    });
  })();
})();

/* ===== Product card: hover image + swatch image swap (was an inline script repeated in every card) ===== */
(function () {
  'use strict';
  if (window.__swatchImgSwap) return;
  window.__swatchImgSwap = true;

  document.addEventListener('mouseover', function (e) {
    if (!e.target.closest) return;
    /* Hover image ships without src (see product-card.liquid): load it on the first hover of its card */
    var swap = e.target.closest('.img-hover-swap');
    var lazy = swap && swap.querySelector('img[data-src]');
    if (lazy) {
      if (lazy.dataset.srcset) lazy.srcset = lazy.dataset.srcset;
      lazy.src = lazy.dataset.src;
      lazy.removeAttribute('data-src');
      lazy.removeAttribute('data-srcset');
    }
    /* Preload this card's swatch variant images on first hover (was: every card at idle) */
    var card = e.target.closest('.group');
    if (card && !card.__swatchPreloaded) {
      card.__swatchPreloaded = true;
      card.querySelectorAll('.js-swatch-dot[data-variant-image]').forEach(function (dot) {
        new Image().src = dot.dataset.variantImage;
      });
    }
    var dot = e.target.closest('.js-swatch-dot[data-variant-image]');
    if (!dot || !card) return;
    var img = card.querySelector('a > img:first-of-type');
    if (!img) return;
    if (!img.dataset.originalSrc) {
      img.dataset.originalSrc = img.src;
      img.dataset.originalSrcset = img.srcset || '';
    }
    img.src = dot.dataset.variantImage;
    img.srcset = '';
  });
  document.addEventListener('mouseout', function (e) {
    var dot = e.target.closest && e.target.closest('.js-swatch-dot[data-variant-image]');
    if (!dot) return;
    if (dot.contains(e.relatedTarget)) return;
    var card = dot.closest('.group');
    if (!card) return;
    var img = card.querySelector('a > img:first-of-type');
    if (!img || !img.dataset.originalSrc) return;
    img.src = img.dataset.originalSrc;
    img.srcset = img.dataset.originalSrcset;
  });
})();

/* ===== Deferred images: <img data-defer-src> (below-the-fold images, see product-card.liquid) and [data-defer-bg] (not used by swatch-links any more) =====
   Native loading="lazy" starts every image near the viewport at first layout, before the LCP image paints,
   and Lighthouse's simulated LCP counts every request started before it. These images get their src only
   after window load + the first frames, when they come near the viewport. Carousel slides are clipped by
   the track, so a carousel loads all its slides once the carousel itself is near. */
(function () {
  'use strict';
  function load(img) {
    if (!img.hasAttribute('data-defer-src')) return;
    var pic = img.parentNode;
    if (pic && pic.tagName === 'PICTURE') {
      pic.querySelectorAll('source[data-defer-srcset]').forEach(function (s) {
        s.srcset = s.getAttribute('data-defer-srcset');
        s.removeAttribute('data-defer-srcset');
      });
    }
    if (img.hasAttribute('data-defer-srcset')) img.srcset = img.getAttribute('data-defer-srcset');
    img.src = img.getAttribute('data-defer-src');
    img.removeAttribute('data-defer-srcset');
    img.removeAttribute('data-defer-src');
  }
  function loadBg(el) {
    if (!el.hasAttribute('data-defer-bg')) return;
    el.style.backgroundImage = 'url("' + el.getAttribute('data-defer-bg') + '")';
    el.removeAttribute('data-defer-bg');
  }
  function start() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('img[data-defer-src]').forEach(load);
      document.querySelectorAll('[data-defer-bg]').forEach(loadBg);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        if (e.target.tagName === 'IMG') load(e.target);
        else {
          e.target.__deferLoaded = true;
          e.target.querySelectorAll('img[data-defer-src]').forEach(load);
          if (e.target.hasAttribute('data-defer-bg')) loadBg(e.target);
          e.target.querySelectorAll('[data-defer-bg]').forEach(loadBg);
        }
      });
    }, { rootMargin: '600px 0px' });
    function watch(root) {
      (root.querySelectorAll ? root : document).querySelectorAll('[data-defer-bg]').forEach(function (el) {
        var grid = el.closest('.swatch-links-grid') || el;
        if (!grid.__deferWatched) { grid.__deferWatched = true; io.observe(grid); }
        else if (grid.__deferLoaded) loadBg(el);
      });
      (root.querySelectorAll ? root : document).querySelectorAll('img[data-defer-src]').forEach(function (img) {
        var group = img.closest('.snap-track, [data-embla-viewport]');
        if (group) {
          if (!group.__deferWatched) { group.__deferWatched = true; io.observe(group); }
          else if (group.__deferLoaded) load(img);
        } else {
          io.observe(img);
        }
      });
    }
    watch(document);
    /* Sections added later (recommendations, recently viewed, cart drawer) */
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        r.addedNodes.forEach(function (n) { if (n.nodeType === 1) watch(n.tagName === 'IMG' ? n.parentNode : n); });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
  var started = false;
  function startOnce() { if (!started) { started = true; start(); } }
  /* Two frames after load = the first paint is on screen. The timeout covers tabs that render no frames yet. */
  function afterFirstFrames() {
    requestAnimationFrame(function () { requestAnimationFrame(startOnce); });
    setTimeout(startOnce, 3000);
  }
  if (document.readyState === 'complete') afterFirstFrames();
  else window.addEventListener('load', afterFirstFrames);
})();

/* ===== Swallow the click that ends a drag on an Embla carousel =====
   Splide swallowed the click after any mouse drag (touch: after 10px). Embla
   only does so past 10px, and only inside its own root, after capture
   listeners on ancestors (the PDP gallery's PhotoSwipe loader on
   #product-gallery) have already seen it: a short drag on a gallery image
   opened the lightbox. The click is stopped here, on window, first. */
(function () {
  var VIEWPORTS = '[x-ref="viewport"], [data-embla-viewport]';
  var start = null, swallow = null, timer = 0;
  function axisY(vp) {
    var c = vp.firstElementChild;
    return !!c && getComputedStyle(c).flexDirection.indexOf('column') === 0;
  }
  window.addEventListener('pointerdown', function (e) {
    swallow = null;
    var vp = e.target.closest && e.target.closest(VIEWPORTS);
    start = vp ? { vp: vp, y: axisY(vp), x0: e.clientX, y0: e.clientY, touch: e.pointerType !== 'mouse', moved: 0 } : null;
  }, true);
  window.addEventListener('pointermove', function (e) {
    if (start) start.moved = Math.max(start.moved, Math.abs(start.y ? e.clientY - start.y0 : e.clientX - start.x0));
  }, { capture: true, passive: true });
  window.addEventListener('pointerup', function () {
    if (start && start.moved > (start.touch ? 10 : 0)) {
      swallow = start.vp;
      clearTimeout(timer);
      timer = setTimeout(function () { swallow = null; }, 400);
    }
    start = null;
  }, true);
  window.addEventListener('click', function (e) {
    if (!swallow || !swallow.contains(e.target)) return;
    swallow = null;
    e.preventDefault();
    e.stopImmediatePropagation();
  }, true);
})();
